import React from 'react'
import { withRouter } from "react-router-dom";
import FormComponent, { FormOp, Validators } from '../../../components/form/FormOps';
import Http from '../../../Http';

class Ciudad extends FormComponent {

  static defaultProps = {
    onSave: () => { }
  }

  componentDidMount() {

    this.formConfig(
      { defaultUrl: 'ciudad/one', saveUrl: 'ciudad/save', backUrl: '/Catalogo/Ciudades' },
      FormOp.Group([
        // FormOp.Field('text', 'ciudad', 'Clave', '', [Validators.required], 2),
        FormOp.Field('text', 'ciudad', 'Ciudad', '', [Validators.required], 5),
        FormOp.Field('select', 'id_estado', 'Estado', '', [Validators.required], 5),
      ],
        ['Guardar'], 'Ciudad'), this.formData)

    if (this.props.match.params.id)
      this.loadFormPreds(this.props.match.params.id)
  }

  formData = async (form) => {
    var Res = await Http.get('ciudad/form');
    // console.log(Res.data);
    if (!Res.error) {
      var estados = FormOp.ModOptions(form, 'id_estado', Res.data, 'id', 'estado');
      return estados;
    }

  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(Ciudad);